module.exports = __webpack_public_path__ + "img/finance.0633275e.svg";